module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "schedule"
  }, [_c('h3', {
    staticClass: "schedule__header"
  }, [_vm._v(_vm._s(_vm.title))]), _c('ul', {
    staticClass: "schedule__table"
  }, _vm._l((_vm.schedule), function(ref, index) {
    var day = ref.day;
    var time = ref.time;

    return _c('li', {
      key: index,
      staticClass: "schedule__day"
    }, [_c('span', {
      staticClass: "schedule__name"
    }, [_vm._v(_vm._s(day))]), (time.length) ? _c('ul', {
      staticClass: "schedule__wrap"
    }, _vm._l((time), function(item, index) {
      return _c('li', {
        key: index,
        staticClass: "schedule__time",
        class: {
          active: item
        }
      }, [_vm._v(_vm._s(item))])
    }), 0) : _vm._e()])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49490d08","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/catalog/card/components/tabs/schedule/components/scheduleblock/ScheduleComponent.vue
// module id = 59ac1d6728c43eb4102c
// module chunks = 5